import { UntypedFormGroup } from '@angular/forms';
import { AfregningDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/afregning-dto';
import { AmountDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/amount-dto';
import { AnlaegDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/anlaeg-dto';
import { G4AfregningerHaltedActionEnum } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/g-4-afregninger-halted-action-enum';
import { FabrikatDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fabrikat-dto';
import { FastprisaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fastprisaftale-dto';
import { HenviserDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/henviser-dto';
import { InstallatoerDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/installatoer-dto';
import { KomponentDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/komponent-dto';
import { KomponentTypeDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/komponent-type-dto';
import { KreditvurderingDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kreditvurdering-dto';
import { KundeDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kunde-dto';
import { ModelDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/model-dto';
import { OpfoelgningDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/opfoelgning-dto';
import { OpkraevningDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/opkraevning-dto';
import { PartnerSubscriptionTypeMappingDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-subscription-type-mapping-dto';
import { PartnerVarenrMappingDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-varenr-mapping-dto';
import { PriceComponentDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/price-component-dto';
import { ProduktDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/produkt-dto';
import { ServiceAbonnementDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/service-abonnement-dto';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { ServiceordreAfregningPostDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-afregning-post-dto';
import { ServiceordreDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-dto';
import { TilvalgDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-dto';
import { TilvalgGroupDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-group-dto';
import { UpcomingChangesDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/upcoming-changes-dto';
import { OpgaveEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/opgave-enum';
import { ProduktEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/produkt-enum';
import { ServiceaftaleStateEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceaftale-state-enum';
import { ServiceordreStatusEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceordre-status-enum';
import { ChangeEffect } from 'src/app/api/models/OK/Egis/Service/Models/Request/change-effect';

export interface KundeInformation {
  okKundeAftaleNr: number;
}

export interface ProduktInformation {
  produktId: ProduktEnum;
  fabrikatId: number;
  alternativFabrikat: string;
  modelId: number;
  alternativModel: string;
  installationDate?: Date;
  effekt: Effekt;
  driftformId: number;
  kondenserende: boolean;
  storbraender: boolean;
  garantiPeriode: number;
  serienummer: string;
  komponenter: any[];
  installatoerId?: number;
  alternativInstallatoer?: string;
}

export interface AbonnementInformation {
  partnerNo: number;
  henviserCvr: string;
  abonnementId: number;
  isActive: boolean;
  startDate: Date;
  nextCheckupDate: Date;
  serviceOrderNote: string;
  fastOrdreNote: string;
  opkraevningDate: Date;
  tagIds: number[];
  opkraevningsinterval: number;
}

export interface TilvalgInformation {
  fastPrisEnabled: boolean;
  fastPris: number;
  fixedPriceStartDate: Date;
  fixedPriceEndDate: Date;
  tilvalg: any[];
  rabatEnabled: boolean;
  rabatKontant: number;
  rabatProcent: number;
  rabatTekst: string;
  rabatSplit: number;
  isEngangsRabat: boolean;
  rabatkampagne: any;
}

export interface CreateTilkaldInformation {
  deadline: Date;
  note: string;
  fastOrdreNote?: string;
  accept: boolean;
  fakturaNote?: string;
  genudkald: boolean;
  telefonservice: boolean;
}

export interface Effekt {
  minEffekt?: number;
  maxEffekt?: number;
}

export interface FastPrisAddEditDialogData {
  fastprisAftale: FastprisaftaleDto;
  editMode: boolean;
  existingFastpriser: FastprisaftaleDto[];
  isPrivatKunde: boolean;
}

export interface AnlaegEditDialogData {
  anlaeg: AnlaegDto;
  product: ProduktDto;
  editMode: boolean;
}

export interface AnlaegEditDialogResponse {
  anlaeg: AnlaegDto;
}

export interface ConfirmDialogData {
  title: string;
  body: string | null;
  submitText?: string;
  cancelText?: string;
  type?: DialogType;
}

export interface ConfirmDialogResponse {
  confirm: boolean;
}

export interface CancelServiceordreDialogData {
  produkt: ProduktEnum;
  ordreType: OpgaveEnum;
}

export interface CancelServiceordreDialogResponse {
  confirm: boolean;
  note?: string;
  resendToNewPartner: boolean;
  newPartnerNo?: number;
}

export interface ServiceaftaleFilter {
  productIds?: null | ProduktEnum[];
  serviceaftaleStateIds?: null | ServiceaftaleStateEnum[];
  serviceaftaleTagIds?: null | number[];
  partnerNos?: null | number[];
  orderBy?: string;
  orderDir?: string;
}

export interface ServiceordreFilter {
  productIds?: null | ProduktEnum[];
  opgaveIds?: null | number[];
  serviceOrderStateIds?: null | number[];
  partnerNos?: null | number[];
  orderBy?: string;
  orderDir?: string;
  showParked?: boolean;
  periodFrom?: Date;
  periodTo?: Date;
}

export interface ForaeldreloeseFilter {
  partnerNos?: null | number[];
  orderBy?: string;
  orderDir?: string;
}

export interface OpkraevningFilter {
  orderBy?: string;
  orderDir?: string;
}

export interface ModelFilter {
  productIds?: null | ProduktEnum[];
  fabrikatIds?: null | number[];
}

export interface PartnerFilter {
  showInactive?: boolean;
}

export interface AnlaegKomponentDialogData {
  editMode: boolean;
  minInstallDate: Date;
  komponentTyper: KomponentTypeDto[];
  komponent: UntypedFormGroup;
  komponenter?: KomponentDto[];
}

export interface EditPartnerDialogData {
  serviceaftale: ServiceaftaleDto;
  upcomingChanges: UpcomingChangesDto;
}

export interface CreateServiceOrdreComponentDialogData {
  serviceaftale: ServiceaftaleDto;
  serviceordre?: ServiceordreDto;
  kreditvurdering?: KreditvurderingDto;
  opgavetype: OpgaveEnum;
  buttonText?: string;
}

export interface KreditstopDialogComponentData {
  serviceordre?: ServiceordreDto;
  kreditvurdering?: KreditvurderingDto;
  partnervalidTo?: string;
}

export interface KreditstopDialogResponse {
  acceptTekst?: string;
  serviceordreStatus: ServiceordreStatusEnum;
}

export interface SettlementHaltedDialogComponentData {
  settlementId: number;
  errorTextG4: string;
  isCreditnote: boolean;
  creditnoteBilagsnr?: number;
  creditnoteOpkraevningDate?: Date;
  agreementNo?: number;
  serviceorderNo?: number;
  amountExclVat?: number;
  amountInclVat?: number;
}

export interface SettlementHaltedDialogResponse {
  settlementId: number;
  g4AfregningerHaltedActionEnum: G4AfregningerHaltedActionEnum;
  creditnoteBilagsnr?: number;
  creditnoteOpkraevningDate?: Date;
}

export interface RabatEditDialogData {
  rabatKontant: number;
  rabatProcent: number;
  rabatTekst: string;
  rabatSplit: number;
  engangsRabat: boolean;
  isPrivatKunde: boolean;
  serviceaftaleId: number;
  maxRabatKontant: number;
  rowVersion: string;
}

export interface OpkraevningsDialogData {
  serviceaftale?: ServiceaftaleDto | null;
  opkraevningsInterval: number;
  opkraevningDate: Date;
  changeEffect: ChangeEffect;
}

export interface OpkraevningsDialogResponse {
  opkraevningsInterval: number;
  changeEffect: ChangeEffect;
}

export interface OpfoelgningDialogData {
  opfoelgninger?: OpfoelgningDto[];
  serviceordre?: ServiceordreDto;
  entityNo: number;
  okKundeAftaleNr?: number;
}

export interface OpfoelgningDialogResponse {
  opfoelgning: OpfoelgningDto;
  action: OpfoelgningAction;
  park?: boolean;
}

export enum OpfoelgningAction {
  Upsert = 0,
  Delete = 1,
}

export interface ServiceintervallerDialogData {
  serviceaftale: ServiceaftaleDto;
}

export interface BetalerDialogData {
  kunde: KundeDto;
}

export interface RejectionData {
  confirm: boolean;
  rejectionRemark: string;
}

export enum DialogType {
  Information = 0,
  Warning = 1,
  Error = 1,
  Confirm = 2,
}

export interface KreditnotaDialogData {
  afregning: AfregningDto;
  serviceaftale: ServiceaftaleDto;
  harPartnerTilbagefoersel: boolean;
  harPartnerAfregning: boolean;
}

export interface AfregningslinieDialogData {
  editMode: boolean;
  afregningsLinje: ServiceordreAfregningPostDto;
  isNaerVarmeLeasingGasTryghed: boolean;
  leveringsDate: Date;
}

export interface KreditnotaDialogResponse {
  comment: string;
  nyFaktura: boolean;
  partnerkorrektion: boolean;
}

export interface PriceDialogData {
  totalPrice: AmountDto;
  listPrice: AmountDto;
  pricecomponents: PriceComponentDto[];
  moms: boolean;
  opkraevning: OpkraevningDto;
}

export interface HenviserDialogData {
  henviser: HenviserDto;
  searchQuery?: string;
  cvr?: string;
  name?: string;
  id?: number;
}

export interface InstallatoerDialogData {
  installatoer: InstallatoerDto;
  searchQuery?: string;
  id?: number;
  cvr?: string;
  name?: string;
}

export interface ServiceabonnementDialogData {
  serviceAbonnement: ServiceAbonnementDto;
}

export interface EditTilvalgDialogData {
  serviceaftale: ServiceaftaleDto;
  overskrift: string;
  buttonTekst: string;
  allowInstantChange?: boolean;
}

export interface ChangeOpgaveTypeDialogData {
  opgaveType: OpgaveEnum;
  serviceOrdreNo: number;
}

export interface FastForwardOpkraevningsdateDialogData {
  intervalStartDate: Date;
  intervalEndDate: Date;
  endDateInInterval: boolean;
}

export interface FastOrdreNoteDialogData {
  serviceaftale: ServiceaftaleDto;
}

export interface TilvalgEditDialogData {
  tilvalg: TilvalgDto;
  tilvalgGroups: TilvalgGroupDto[];
}

export interface ServiceabonnementTilvalgRelationDialogData {
  serviceabonnement: ServiceAbonnementDto;
}

export interface PartnerChangeData {
  validFrom: Date;
  partnerNo: number;
}

export interface PartnerChangeDialogData {
  currentPartnerNo: number;
}

export interface EditHistoryRemarkDialogData {
  currentRemark: string;
}

export interface ServiceintervalChartItem {
  startDate: Date;
  endDate: Date;
  classes: string[];
  comments: string[];
}

export interface DateClassMatch {
  date: Date;
  class: string;
  comment: string;
}

export interface ServiceintervalChartItem {
  startDate: Date;
  endDate: Date;
  classes: string[];
  comments: string[];
}

export interface EditModelDialogData {
  fabrikater: FabrikatDto[];
  model?: ModelDto | null;
  fabrikat?: FabrikatDto | null;
  produkt?: ProduktDto | null;
}

export interface EditFabrikatDialogData {
  fabrikat?: FabrikatDto | null;
}

export interface PartnerPayloadDialogData {
  payload: string;
  receivedDate: string;
}

export interface PartnerVarenrMappingDialogData {
  partnerVarenrMapping: PartnerVarenrMappingDto;
}

export interface PartnerAbonnementerEditDialogData {
  partnerSubscriptionTypeMapping: PartnerSubscriptionTypeMappingDto;
}
